<template>
    <div class="page">

        <!-- 广告 -->
        <div class="banner-container">

            <swiper ref="mySwiper" :options="swiperOptions">
                <swiper-slide v-for="item in bannerList" :key="item.bannerId">
                    <a :href="item.clickUrl" target="_blank">
                        <img class="banner-img" :src="item.bannerUrl">
                    </a>
                </swiper-slide>
                <div class="swiper-pagination" slot="pagination"></div>
            </swiper>

        </div>

        <!-- 产品列表 -->
        <div class="product-group-container">

            <div class="group-content" v-for="item in showProductList" :key="item.cateId" :data-name="item.cateId">

                <div class="title-box" v-html=" item.cateName "></div>

                <div class="group-list-box">

                    <div class="group-item" 
                    v-for="productItme in showProdBoList(item.wmProdBoList)" 
                    :key="productItme.prodName" 
                    @click="toLink(productItme)">
                        <div class="w-btn product-box">
                            <div class="cover-content">
                                <img :src="productItme.coverUrl">
                            </div>
                            <div class="info-content">
                                <p class="name" :title="productItme.prodName" v-html="productItme.prodName"></p>
                                <p class="price" v-text="`￥${productItme.prodPrice}/本起`"></p>
                            </div>
                        </div>
                    </div>

                </div>
                
            </div>


        </div>

    </div>
</template>

<script>

import { mapState } from "vuex"
import { getBannerListApi } from "@/api/index"

import { Swiper, SwiperSlide, directive } from 'vue-awesome-swiper'

import 'swiper/css/swiper.css'

export default {
    name: "",

    data() {
        return {
            // 焦点图配置
            swiperOptions: {
                pagination: {
                    el: '.swiper-pagination'
                },
                autoplay: true,
                loop: true
            },
        };
    },

    computed: {
        ...mapState(['bannerList', 'productList']),

        showProductList(){
            return this.productList.filter((item)=>{ return item.wmProdBoList.length && item.wmProdBoList.filter( item=>{ return item.upState } ).length })
        },
    },

    components: {
        Swiper,
        SwiperSlide
    },
    directives: {
        swiper: directive
    },

    methods: {
        //
        getBannerList(){
            getBannerListApi().then(res=>{
                if( res.data.code != 200 ){
                    alert( res.data.msg )
                    return
                }

                this.$store.commit('setState', {
                    bannerList: res.data.data
                })
            })
        },

        //跳到微店产品详情
        toLink(item){
            this.$router.push(`/detail/${item.prodId}`)
            // window.open(`https://100001196622.retail.n.weimob.com/saas/retail/100001196622/2260049622/goods/detail/vwif?id=${item.prodId}`)
        },

        
        showProdBoList(list){
            return list.filter( item=>{ return item.upState } )
        },

        //banner点击跳转
        onBanner(clickUrl){
            window.open(clickUrl)
        }
    },

    created() {
        this.getBannerList()
    },
    mounted() {}
};
</script>

<style lang="less" scoped>
.page{
    min-height: 70vh;

    padding-top: 100px;

    .banner-container{
        font-size: 0;

        .banner-img{
            width: 100%;
            cursor: pointer;
        }
    }

    .product-group-container{
        width: 1024px;
        margin: 60px auto;
        .group-content{
            margin-bottom: 40px;

            // 标题
            .title-box{
                position: relative;
                color: #333;
                font-size: 24px;
                text-align: center;
                height: 50px;
                &::after{
                    content: '';
                    position: absolute;
                    width: 90px;
                    height: 4px;
                    background: #caaa9a;
                    bottom: 0;
                    left: 50%;
                    transform: translateX(-50%);
                }
            }
            // 列表容器
            .group-list-box{
                display: flex;
                flex-wrap: wrap;
                .group-item{
                    display: flex;
                    margin: 40px 92px 40px 0;
                    width: 280px;
                    &:nth-of-type(3n){
                        margin-right: 0;
                    }

                    .product-box{
                        overflow: hidden;
                        box-shadow: 0px 0px 7px 1px rgba(0,0,0,.2);
                        background: #fff;

                        transition: all .3s;

                        &:hover{
                            transform: translateY(-3px);
                        }

                        .cover-content{
                            width: 280px;
                            height: 280px;
                            img{
                                max-width: 280px;
                                max-height: 280px;
                            }
                        }
                        .info-content{
                            display: flex;
                            align-items: center;
                            justify-content: space-around;

                            height: 60px;
                            .name{
                                color: #333;
                                font-size: 18px;
                                width: 150px;
                                overflow: hidden;
                                white-space: nowrap;
                                text-overflow: ellipsis;
                            }
                            .price{
                                color: #caaa9a;
                                font-size: 14px;
                            }
                        }
                    }
                }
            }
        }
    }

}
</style>